"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_apps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "apps-hi"), /*#__PURE__*/React.createElement("g", {
    id: "9035e33c-1aec-431e-a17f-74fa921d1979",
    "data-name": "Apps_ic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dd367c80-0ccb-4209-9a7c-421a49908d52",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "f6db1f08-a708-465b-bfc0-e4611b53f674",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 144,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 70,
    r: 18,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 52,
    width: 36,
    height: 36,
    rx: 8,
    ry: 8,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,54A18,18,0,0,1,83.95,71c0-.33.05-.66.05-1a18,18,0,1,0-36,0c0,.34,0,.67.05,1A18,18,0,0,1,66,54Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,52H114a8,8,0,0,0-8,8v2a8,8,0,0,1,8-8h20a8,8,0,0,1,8,8V60A8,8,0,0,0,134,52Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25,141.68H81.75a4.17,4.17,0,0,0,3.62-6.34L69.62,110a4.28,4.28,0,0,0-7.23,0L46.63,135.34A4.17,4.17,0,0,0,50.25,141.68Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.31,137l-5.51-16.95a4.29,4.29,0,0,1,1.56-4.8l14.42-10.47a4.29,4.29,0,0,1,5,0l14.42,10.47a4.29,4.29,0,0,1,1.56,4.8L136.28,137a4.29,4.29,0,0,1-4.08,3H114.38A4.29,4.29,0,0,1,110.31,137Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,118.09,136.28,135a4.29,4.29,0,0,1-4.08,3H114.38a4.29,4.29,0,0,1-4.08-3l-5.51-16.95c0-.11,0-.22-.05-.33a4.25,4.25,0,0,0,.05,2.33L110.31,137a4.29,4.29,0,0,0,4.08,3H132.2a4.29,4.29,0,0,0,4.08-3l5.51-16.95a4.24,4.24,0,0,0,.05-2.33C141.82,117.87,141.83,118,141.79,118.09Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.63,137.34,62.38,112a4.28,4.28,0,0,1,7.23,0l15.75,25.35a4.13,4.13,0,0,1,.49,1.19,4,4,0,0,0-.49-3.19L69.62,110a4.28,4.28,0,0,0-7.23,0L46.63,135.34a4,4,0,0,0-.49,3.19A4.13,4.13,0,0,1,46.63,137.34Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))));
}

var _default = ic_apps;
exports.default = _default;